/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export { default as LoginForm } from './LoginForm';
